










import Vue from 'vue'
import { TitleElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'TitleEl',

  computed: {
    getAlign (): string {
      return `text-align: ${this.$props.templateItemData.align || 'center'};`
    },
    getBackground (): string {
      return `background-color: ${this.$props.templateItemData.background || 'transparent'};`
    },
    getColor (): string {
      return `color: ${this.$props.templateItemData.color || 'inherit'};`
    },
    fontSize (): string {
      let size: string
      switch (this.$props.templateItemData.size) {
        case 'large':
          size = '1.5rem'
          break
        case 'medium':
          size = '1.25rem'
          break
        default:
          size = '1.1rem'
          break
      }
      return `font-size: ${size};`
    }
  },

  props: {
    templateItemData: {
      type: Object as () => TitleElInterface,
      required: true
    }
  }
})
